var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-cart-footer"},[_c('base-link',{attrs:{"href":_vm.url,"variant":"primary-button"}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }